// Enrolment base roles for users in canvas courses.
// The preference for each base role, higher number means it's preferred.
export const ROLE_ORDER = {
  'TeacherEnrollment': 5,
  'DesignerEnrollment': 4,
  'TaEnrollment': 3,
  'StudentEnrollment': 2,
  'ObserverEnrollment': 1
}

export const ERRORS = {
  LOGIN: 'LoginError',
  UNAUTHORIZED: 'Unauthorized Error',
  BAD_REQUEST: 'BadRequestError'
}